import { Lock } from "lucide-react";

const INK = "#131822";

export const STATUS_META = {
  completed: { label: "Completed", color: "#0E7A66" },
  in_progress: { label: "In progress", color: "#1D5FD4" },
  signed_up: { label: "Signed up", color: "#8A5808" },
  invited: { label: "Invited", color: "rgba(19,24,34,0.55)" },
};

export function StatusPill({ status }) {
  const meta = STATUS_META[status] || STATUS_META.invited;
  return (
    <span
      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium"
      style={{ color: meta.color, background: `color-mix(in srgb, ${meta.color} 12%, white)`, border: `1px solid color-mix(in srgb, ${meta.color} 22%, transparent)` }}
      data-testid={`status-pill-${status}`}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: meta.color }} />
      {meta.label}
    </span>
  );
}

export function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="flex flex-wrap justify-between items-end gap-4 mb-8 pb-4" style={{ borderBottom: "1px solid rgba(19,24,34,0.1)" }}>
      <div>
        <h1 className="tracking-tight" style={{ fontFamily: "Archivo, sans-serif", fontSize: "1.9rem", fontWeight: 600, color: INK }} data-testid="admin-page-title">
          {title}
        </h1>
        {subtitle && <p className="mt-1.5 text-sm" style={{ color: "rgba(19,24,34,0.65)", maxWidth: "46rem", lineHeight: 1.5 }}>{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}

export function KpiCard({ label, value, sub, accent = "#131822", testId }) {
  return (
    <div className="k-card" style={{ padding: "1.25rem 1.4rem" }} data-testid={testId}>
      <div className="text-xs uppercase tracking-wide" style={{ color: "rgba(19,24,34,0.55)", fontWeight: 600 }}>{label}</div>
      <div className="klareet-mono mt-2" style={{ fontSize: "2.1rem", fontWeight: 300, letterSpacing: "-0.02em", color: accent, lineHeight: 1 }} data-testid={testId ? `${testId}-value` : undefined}>
        {value}
      </div>
      {sub && <div className="text-xs mt-1.5" style={{ color: "rgba(19,24,34,0.6)" }}>{sub}</div>}
    </div>
  );
}

export function PrivacyBadge({ label = "Aggregate only. No individual read." }) {
  return (
    <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs" style={{ color: "#0E7A66", background: "rgba(14,122,102,0.1)", border: "1px solid rgba(14,122,102,0.2)" }} data-testid="privacy-badge">
      <Lock size={12} /> {label}
    </span>
  );
}
